const ProfileCreatedModalIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="204"
      height="200"
      viewBox="0 0 204 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M195.191 111.536C195.191 111.536 195.163 55.1641 164.971 28.2401C138.319 4.47211 101.627 -0.35589 76.9865 27.1281C68.2065 36.9201 57.5905 47.1281 46.5625 53.9681C34.2025 61.6401 19.7625 65.1441 11.3345 90.5441C2.90653 115.944 15.9505 153.196 35.0625 166.384C54.1745 179.572 84.1225 174.672 109.863 169.156C135.603 163.64 192.947 181.488 195.191 111.536Z"
        fill="#85C553"
      />
      <path
        opacity="0.7"
        d="M195.191 111.536C195.191 111.536 195.163 55.1641 164.971 28.2401C138.319 4.47211 101.627 -0.35589 76.9865 27.1281C68.2065 36.9201 57.5905 47.1281 46.5625 53.9681C34.2025 61.6401 19.7625 65.1441 11.3345 90.5441C2.90653 115.944 15.9505 153.196 35.0625 166.384C54.1745 179.572 84.1225 174.672 109.863 169.156C135.603 163.64 192.947 181.488 195.191 111.536Z"
        fill="white"
      />
      <path
        opacity="0.16"
        d="M103.422 191.996C137.308 191.996 164.778 188.646 164.778 184.512C164.778 180.379 137.308 177.028 103.422 177.028C69.5364 177.028 42.0664 180.379 42.0664 184.512C42.0664 188.646 69.5364 191.996 103.422 191.996Z"
        fill="black"
      />
      <path
        opacity="0.07"
        d="M164.971 28.2362C160.779 24.4838 156.231 21.1493 151.391 18.2802L111.463 78.2802L165.719 28.9242C165.475 28.6922 165.227 28.4722 164.971 28.2362ZM129.239 9.59616C123.013 8.29965 116.614 8.05493 110.307 8.87216L111.463 78.2762L129.239 9.59616ZM87.3909 17.8562C83.5773 20.5343 80.0874 23.6457 76.9909 27.1282C75.9082 28.3415 74.7949 29.5575 73.6509 30.7762L111.467 78.2842L87.3909 17.8562ZM54.6349 48.3442C52.0419 50.3534 49.3491 52.2305 46.5669 53.9682C40.5789 57.6722 34.1189 60.4202 28.0589 65.1442L111.463 78.2842L54.6349 48.3442ZM8.87489 103.596C8.14289 114.424 10.1949 126.144 14.1669 136.744L111.463 78.2842L8.87489 103.596ZM111.463 78.2842L42.0029 170.216C52.1069 174.616 64.2549 175.416 76.8429 174.448L111.463 78.2842ZM111.463 78.2842L114.767 168.396C121.907 167.632 130.627 167.868 139.659 167.48L111.463 78.2842ZM189.439 140.724L111.463 78.2842L172.175 160.128C179.243 156.172 185.319 150.096 189.439 140.724ZM192.739 86.8722L111.463 78.2842L195.115 108.576C194.781 101.299 193.988 94.0495 192.739 86.8722ZM179.575 47.0002L111.463 78.2842L186.723 63.2122C184.799 57.6172 182.408 52.1941 179.575 47.0002Z"
        fill="black"
      />
      <path
        d="M181.959 134.984C181.959 134.984 177.643 133.524 176.359 132.632C175.075 131.74 171.791 128.444 171.027 125.904C170.367 123.56 169.93 121.159 169.719 118.732C169.527 116.764 168.703 116.256 167.495 117.78C166.287 119.304 165.895 121.78 166.227 123.38C166.559 124.98 167.559 126.808 167.427 127.128C167.295 127.448 167.107 128.08 167.107 128.08C167.107 128.08 163.235 127.636 161.079 127.128C158.923 126.62 157.207 126.428 157.079 127.444C156.951 128.46 157.395 130.048 157.523 131.128C157.651 132.208 159.299 136.968 160.127 138.044C160.713 138.882 161.394 139.649 162.155 140.332C162.663 140.712 162.663 141.028 163.871 141.156C164.894 141.248 165.912 141.396 166.919 141.6C167.363 141.728 167.807 142.172 169.903 142.108C171.22 142.063 172.533 141.936 173.835 141.728L180.119 144.072L181.959 134.984Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M179.927 133.776L177.323 145.076L181.579 146.788L183.735 135.048L179.927 133.776Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M190.647 135.936L182.339 133.904L179.291 147.36L190.599 152.636L190.647 151.616V135.936Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M166.851 128.636C166.851 128.636 166.279 132.072 166.279 132.872C166.279 133.672 168.055 135.92 168.679 136.044"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M165.579 137.272C165.579 137.272 166.471 137.588 166.215 138.352C165.959 139.116 164.055 140.192 163.167 140.7C162.279 141.208 161.967 141.144 160.947 140.572C160.347 140.241 159.894 139.697 159.675 139.048C160.315 139.032 160.952 138.97 161.583 138.86L165.579 137.272Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M158.279 135.616C158.279 135.616 158.279 138.536 158.979 138.792C159.647 139.05 160.358 139.179 161.075 139.172C161.519 139.108 164.503 138.092 165.075 137.712C165.647 137.332 166.219 136.512 165.903 135.744L165.583 134.984C164.618 135.149 163.641 135.234 162.663 135.236C161.063 135.236 158.411 134.728 158.219 134.92C158.027 135.112 158.279 135.616 158.279 135.616Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M157.319 131.672C157.192 131.753 157.09 131.867 157.023 132.002C156.956 132.136 156.927 132.287 156.939 132.436C156.939 133.008 156.179 134.72 157.067 135.292C157.955 135.864 160.747 136.308 161.319 136.308C161.891 136.308 165.255 135.108 165.571 134.976C165.887 134.844 165.891 133.704 165.763 133.26C165.635 132.816 164.495 132.688 164.495 132.688C164.495 132.688 159.615 132.572 157.319 131.672Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M158.979 127.808C158.979 127.808 161.011 129.332 161.379 129.46L164.491 130.54C164.491 130.54 164.891 130.728 164.891 131.492C164.884 131.821 164.759 132.137 164.539 132.381C164.318 132.626 164.017 132.783 163.691 132.824C163.059 132.952 160.771 133.332 159.947 133.016C158.824 132.461 157.742 131.824 156.711 131.112C156.139 130.712 156.075 130.22 156.391 129.512C156.666 128.828 156.899 128.128 157.091 127.416"
        fill="white"
      />
      <path
        d="M158.979 127.808C158.979 127.808 161.011 129.332 161.379 129.46L164.491 130.54C164.491 130.54 164.891 130.728 164.891 131.492C164.884 131.821 164.759 132.137 164.539 132.381C164.318 132.626 164.017 132.783 163.691 132.824C163.059 132.952 160.771 133.332 159.947 133.016C158.824 132.461 157.742 131.824 156.711 131.112C156.139 130.712 156.075 130.22 156.391 129.512C156.666 128.828 156.899 128.128 157.091 127.416"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M169.318 36.8241C169.318 36.8241 164.954 38.1481 163.406 38.1641C161.858 38.1801 157.25 37.4161 155.154 35.7921C153.247 34.2759 151.487 32.583 149.898 30.7361C148.598 29.2441 147.63 29.3121 147.534 31.2521C147.438 33.1921 148.57 35.4281 149.754 36.5361C150.938 37.6441 152.83 38.5361 152.914 38.8801C152.998 39.2241 153.21 39.8401 153.21 39.8401C153.21 39.8401 149.802 41.7321 147.75 42.5721C145.698 43.4121 144.194 44.2601 144.682 45.1601C145.17 46.0601 146.454 47.0921 147.186 47.8961C147.918 48.7001 152.03 51.6081 153.33 52.0081C154.295 52.345 155.295 52.5718 156.31 52.6841C156.946 52.6841 157.11 52.9561 158.186 52.3601C159.07 51.8367 159.984 51.3652 160.922 50.9481C161.358 50.7921 161.978 50.8961 163.642 49.6241C164.689 48.82 165.684 47.9517 166.622 47.0241L173.102 45.2761L169.318 36.8241Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M166.958 37.0243L171.418 47.7283L175.874 46.6483L170.794 35.8403L166.958 37.0243Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M176.934 32.5439L168.994 35.7239L174.346 48.4399L186.61 46.1519L186.058 45.2959L176.934 32.5439Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M153.318 40.4722C153.318 40.4722 154.85 43.5922 155.318 44.2642C155.786 44.9362 158.518 45.7082 159.126 45.4402"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M157.319 48.2123C157.319 48.2123 158.227 47.9523 158.463 48.7203C158.699 49.4883 157.779 51.4723 157.351 52.4043C156.923 53.3363 156.631 53.4683 155.471 53.6043C154.791 53.6849 154.105 53.5064 153.551 53.1043C154.062 52.7199 154.543 52.2973 154.991 51.8403L157.319 48.2123Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M150.427 51.1161C150.427 51.1161 152.123 53.4921 152.827 53.2921C153.521 53.1124 154.174 52.8044 154.755 52.3841C155.079 52.0721 156.915 49.5121 157.155 48.8681C157.395 48.2241 157.383 47.2241 156.683 46.7881L155.983 46.3521C155.294 47.0486 154.549 47.6868 153.755 48.2601C152.463 49.1801 149.999 50.3201 149.955 50.5841C149.911 50.8481 150.427 51.1161 150.427 51.1161Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M147.358 48.4723C147.303 48.6122 147.287 48.7644 147.31 48.913C147.334 49.0615 147.398 49.2009 147.494 49.3163C147.826 49.7803 148.202 51.6163 149.258 51.5643C150.314 51.5123 152.859 50.2483 153.311 49.9163C153.763 49.5843 155.806 46.6443 155.994 46.3563C156.182 46.0683 155.51 45.1563 155.15 44.8523C154.79 44.5483 153.787 45.1283 153.787 45.1283C153.787 45.1283 149.718 47.8643 147.358 48.4723Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M146.45 44.3599C146.45 44.3599 148.986 44.4159 149.37 44.2999C149.754 44.1839 152.53 43.3679 152.53 43.3679C152.53 43.3679 152.95 43.2999 153.394 43.9199C153.581 44.1921 153.664 44.5229 153.625 44.851C153.587 45.1791 153.431 45.4822 153.186 45.7039C152.746 46.1799 151.11 47.8159 150.254 48.0399C149.016 48.2416 147.765 48.3539 146.51 48.3759C145.826 48.3759 145.478 48.0199 145.31 47.2679C145.134 46.5531 144.917 45.8492 144.658 45.1599"
        fill="white"
      />
      <path
        d="M146.45 44.3599C146.45 44.3599 148.986 44.4159 149.37 44.2999C149.754 44.1839 152.53 43.3679 152.53 43.3679C152.53 43.3679 152.95 43.2999 153.394 43.9199C153.581 44.1921 153.664 44.5229 153.625 44.851C153.587 45.1791 153.431 45.4822 153.186 45.7039C152.746 46.1799 151.11 47.8159 150.254 48.0399C149.016 48.2416 147.765 48.3539 146.51 48.3759C145.826 48.3759 145.478 48.0199 145.31 47.2679C145.134 46.5531 144.917 45.8492 144.658 45.1599"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M29.6553 133.548C29.6553 133.548 33.9713 132.088 35.2553 131.2C36.5393 130.312 39.8113 127.008 40.5713 124.472C41.2419 122.129 41.6893 119.728 41.9073 117.3C42.0953 115.332 42.9233 114.824 44.1273 116.348C45.3313 117.872 45.7273 120.348 45.3953 121.948C45.0633 123.548 44.0633 125.376 44.1953 125.692C44.3273 126.008 44.5113 126.644 44.5113 126.644C44.5113 126.644 48.3833 126.2 50.5433 125.692C52.7033 125.184 54.4153 124.992 54.5433 126.008C54.6713 127.024 54.2233 128.612 54.0993 129.692C53.9753 130.772 52.3193 135.532 51.4953 136.612C50.9076 137.449 50.2258 138.215 49.4633 138.896C48.9553 139.296 48.9553 139.596 47.7513 139.72C46.7281 139.814 45.7106 139.962 44.7033 140.164C44.2593 140.292 43.8153 140.736 41.7193 140.672C40.4007 140.627 39.0862 140.5 37.7833 140.292L31.4993 142.64L29.6553 133.548Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M31.687 132.34L34.287 143.64L30.035 145.356L27.875 133.612L31.687 132.34Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M20.9629 134.5L29.2709 132.468L32.3189 145.924L21.0149 151.2L20.9629 150.18V134.5Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M44.7626 127.2C44.7626 127.2 45.3346 130.628 45.3346 131.452C45.3346 132.276 43.5546 134.5 42.9346 134.628"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M46.0306 135.832C46.0306 135.832 45.1426 136.152 45.3946 136.912C45.6466 137.672 47.5546 138.752 48.4426 139.26C49.3306 139.768 49.6426 139.704 50.6666 139.132C51.2657 138.803 51.7186 138.26 51.9346 137.612C51.296 137.597 50.6595 137.532 50.0306 137.42L46.0306 135.832Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.3184 134.184C53.3184 134.184 53.3184 137.104 52.6224 137.356C51.9559 137.623 51.2443 137.759 50.5264 137.756C50.0824 137.692 47.0984 136.68 46.5264 136.296C45.9544 135.912 45.3824 135.096 45.7024 134.328L46.0184 133.568C46.9831 133.733 47.9598 133.818 48.9384 133.82C50.5384 133.82 53.1904 133.312 53.3824 133.504C53.5744 133.696 53.3184 134.184 53.3184 134.184Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M54.2829 130.248C54.4149 130.324 54.5227 130.435 54.5935 130.57C54.6644 130.704 54.6954 130.856 54.6829 131.008C54.6829 131.58 55.4469 133.292 54.5589 133.864C53.6709 134.436 50.8549 134.872 50.2829 134.872C49.7109 134.872 46.3469 133.672 46.0309 133.54C45.7149 133.408 45.7149 132.268 45.8429 131.824C45.9709 131.38 47.1109 131.256 47.1109 131.256C47.1109 131.256 51.9989 131.136 54.2829 130.248Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.6347 126.376C52.6347 126.376 50.6027 127.896 50.2347 128.024C49.8667 128.152 47.1227 129.104 47.1227 129.104C47.1227 129.104 46.7227 129.296 46.7227 130.056C46.7288 130.385 46.8536 130.701 47.074 130.946C47.2945 131.191 47.5958 131.348 47.9227 131.388C48.5587 131.516 50.8427 131.896 51.6707 131.58C52.7986 131.024 53.8842 130.387 54.9187 129.672C55.4907 129.292 55.5547 128.784 55.2347 128.072C54.9619 127.388 54.7295 126.688 54.5387 125.976"
        fill="white"
      />
      <path
        d="M52.6347 126.376C52.6347 126.376 50.6027 127.896 50.2347 128.024C49.8667 128.152 47.1227 129.104 47.1227 129.104C47.1227 129.104 46.7227 129.296 46.7227 130.056C46.7288 130.385 46.8536 130.701 47.074 130.946C47.2945 131.191 47.5958 131.348 47.9227 131.388C48.5587 131.516 50.8427 131.896 51.6707 131.58C52.7986 131.024 53.8842 130.387 54.9187 129.672C55.4907 129.292 55.5547 128.784 55.2347 128.072C54.9619 127.388 54.7295 126.688 54.5387 125.976"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M34.3465 40.6244C34.3465 40.6244 38.7065 41.9484 40.2585 41.9644C41.8105 41.9804 46.4105 41.2164 48.5105 39.5924C50.4177 38.0762 52.1775 36.3833 53.7665 34.5364C55.0665 33.0444 56.0345 33.1124 56.1265 35.0524C56.2185 36.9924 55.0905 39.2284 53.9105 40.3364C52.7305 41.4444 50.8305 42.3364 50.7505 42.6804C50.6705 43.0244 50.4545 43.6404 50.4545 43.6404C50.4545 43.6404 53.8625 45.5284 55.9145 46.3724C57.9665 47.2164 59.4705 48.0564 58.9825 48.9564C58.4945 49.8564 57.2105 50.8884 56.4785 51.6924C55.7465 52.4964 51.6345 55.4084 50.3345 55.8084C49.3698 56.1453 48.3701 56.3721 47.3545 56.4844C46.7185 56.4844 46.5545 56.7564 45.4785 56.1564C44.5925 55.637 43.6791 55.1657 42.7425 54.7444C42.3065 54.5924 41.6865 54.6924 40.0185 53.4244C38.974 52.6197 37.9801 51.7514 37.0425 50.8244L30.5625 49.0764L34.3465 40.6244Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M36.7031 40.8246L32.2431 51.5286L27.7871 50.4486L32.8671 39.6406L36.7031 40.8246Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M26.7268 36.3442L34.6668 39.5242L29.3148 52.2402L17.0508 49.9522L17.6028 49.0922L26.7268 36.3442Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M50.3305 44.2524C50.3305 44.2524 48.7985 47.3724 48.3305 48.0404C47.8625 48.7084 45.1305 49.4844 44.5225 49.2404"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M46.3384 52.0126C46.3384 52.0126 45.4304 51.7526 45.1944 52.5206C44.9584 53.2886 45.8784 55.2726 46.3064 56.2006C46.7344 57.1286 47.0264 57.2646 48.1864 57.4006C48.8663 57.4788 49.551 57.3005 50.1064 56.9006C49.5952 56.5162 49.1138 56.0936 48.6664 55.6366L46.3384 52.0126Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.2349 54.9163C53.2349 54.9163 51.5349 57.2923 50.8349 57.0923C50.1399 56.9141 49.4855 56.6045 48.9069 56.1803C48.5829 55.8723 46.7469 53.3083 46.5069 52.6683C46.2669 52.0283 46.2829 51.0203 46.9829 50.5883L47.6829 50.1523C48.3699 50.8494 49.1152 51.4864 49.9109 52.0563C51.2029 52.9803 53.6669 54.1203 53.7109 54.3843C53.7549 54.6483 53.2349 54.9163 53.2349 54.9163Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.2984 52.2682C56.3552 52.4075 56.3729 52.5598 56.3496 52.7085C56.3264 52.8572 56.263 52.9968 56.1664 53.1122C55.8344 53.5762 55.4544 55.4122 54.4024 55.3602C53.3504 55.3082 50.8024 54.0442 50.3504 53.7122C49.8984 53.3802 47.8504 50.4402 47.6664 50.1522C47.4824 49.8642 48.1464 48.9522 48.5104 48.6482C48.8744 48.3442 49.8744 48.9202 49.8744 48.9202C49.8744 48.9202 53.9224 51.6722 56.2984 52.2682Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.2109 48.1605C57.2109 48.1605 54.6709 48.2165 54.2869 48.1005C53.9029 47.9845 51.1309 47.1645 51.1309 47.1645C51.1309 47.1645 50.7309 47.1005 50.2669 47.7205C50.08 47.9924 49.9977 48.3228 50.0352 48.6506C50.0727 48.9785 50.2274 49.2817 50.4709 49.5045C50.9149 49.9765 52.5509 51.6165 53.4069 51.8405C54.645 52.0429 55.8964 52.1539 57.1509 52.1725C57.8349 52.1965 58.1829 51.8205 58.3309 51.0685C58.5069 50.3524 58.7246 49.6472 58.9829 48.9565"
        fill="white"
      />
      <path
        d="M57.2109 48.1605C57.2109 48.1605 54.6709 48.2165 54.2869 48.1005C53.9029 47.9845 51.1309 47.1645 51.1309 47.1645C51.1309 47.1645 50.7309 47.1005 50.2669 47.7205C50.08 47.9924 49.9977 48.3228 50.0352 48.6506C50.0727 48.9785 50.2274 49.2817 50.4709 49.5045C50.9149 49.9765 52.5509 51.6165 53.4069 51.8405C54.645 52.0429 55.8964 52.1539 57.1509 52.1725C57.8349 52.1965 58.1829 51.8205 58.3309 51.0685C58.5069 50.3524 58.7246 49.6472 58.9829 48.9565"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M92.9181 98.6121C92.9181 98.6121 90.1181 110.876 90.0061 116.644C89.8941 122.412 90.2141 143.2 90.3221 147.66C90.4301 152.12 92.3901 166.596 92.3901 167.9C92.3901 169.204 92.7181 171.708 92.7181 171.708L91.8461 176.388C90.9928 177.047 90.0825 177.63 89.1261 178.128C87.1661 179.216 84.8821 180.632 84.2301 181.392C84.1507 181.484 84.0944 181.593 84.066 181.711C84.0376 181.828 84.0379 181.951 84.0669 182.069C84.0959 182.186 84.1528 182.295 84.2327 182.386C84.3126 182.478 84.4133 182.548 84.5261 182.592C85.3019 182.896 86.1191 183.081 86.9501 183.14C88.7981 183.248 91.8461 183.248 93.4781 182.812C95.1101 182.376 96.4181 180.964 97.1781 180.412L97.9421 179.868L98.0501 181.068C98.4165 181.014 98.7796 180.941 99.1381 180.848C99.9367 180.618 100.704 180.29 101.422 179.872C101.422 179.872 101.53 178.02 101.53 176.932C101.53 175.844 100.986 173.884 100.878 173.452C100.77 173.02 100.878 169.096 100.554 167.792C100.23 166.488 100.01 166.812 99.7901 164.42C99.5701 162.028 101.53 139.388 101.422 138.736C101.314 138.084 104.19 118.472 104.19 118.472C104.19 118.472 109.69 144.072 111.43 148.972C113.17 153.872 114.042 163.336 114.042 163.992C114.042 164.648 115.022 172.368 115.458 173.46C115.894 174.552 117.09 177.92 117.09 177.92C117.09 177.92 118.83 180.532 119.59 181.836C120.35 183.14 122.966 184.236 124.922 184.556C126.878 184.876 128.406 184.992 128.522 182.38C128.638 179.768 127.654 178.028 126.018 176.832C124.382 175.636 124.062 174.548 124.062 174.548C124.181 172.95 124.181 171.346 124.062 169.748C123.842 167.896 122.646 166.48 122.538 162.672C122.43 158.864 121.666 138.84 121.014 135.684C120.362 132.528 119.502 111.416 119.61 108.484C119.718 105.552 119.334 97.3601 119.334 97.3601L92.8381 97.0601L92.9181 98.6121Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M103.318 54.768C103.318 54.768 99.2744 57.168 96.4104 58.584C93.5464 60 90.0504 60.824 89.6944 61.628C89.3384 62.432 83.1584 75.6 81.9944 77.388C80.8304 79.176 78.0544 82.672 78.5904 84.64C79.1264 86.608 81.3664 89.296 82.7984 89.12C84.2304 88.944 87.0984 88.132 88.2624 86.076C89.4264 84.02 92.2024 77.388 92.2024 77.388C92.2024 77.388 92.6504 83.568 92.5584 86.612C92.4664 89.656 92.4704 92.164 92.2904 93.684C92.1104 95.204 91.3064 97.088 91.6624 97.624C92.0184 98.16 92.4624 98.7 92.9184 98.612C93.3744 98.524 100.082 98.432 102.118 98.52C104.154 98.608 113.49 98.52 115.462 98.612C117.434 98.704 119.134 97.716 119.31 97.356C119.486 96.996 119.85 96.46 119.67 94.492C119.49 92.524 119.85 86.524 120.386 84.196C120.922 81.868 124.146 72.912 124.146 72.912C124.146 72.912 132.654 79.628 134.446 80.164C136.238 80.7 141.07 79.896 142.682 77.928C144.294 75.96 144.83 74.432 143.846 73.092C142.862 71.752 139.278 70.496 135.518 66.464C131.758 62.432 130.318 60.556 127.73 59.3C125.142 58.044 119.85 56.348 118.594 55.808C117.338 55.268 116.994 55.008 116.194 54.644C115.394 54.28 113.506 53.572 110.014 53.48C107.721 53.4803 105.448 53.9175 103.318 54.768Z"
        fill="#85C553"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M90.3948 71.0439C90.5188 71.4759 92.1988 77.3879 92.1988 77.3879L89.7188 72.4719"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M124.162 72.9121C123.79 72.9121 120.271 70.9121 120.271 70.9121"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M118.479 70.6763C118.479 70.6763 119.899 72.5283 121.135 72.8963"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M102.815 60.2601L103.939 64.5041C103.939 64.5041 100.379 82.3001 99.8189 85.3041C99.4778 87.1191 99.2481 88.9532 99.1309 90.7961L102.251 96.9761L106.187 90.2961C106.187 90.2961 105.811 81.8681 105.687 75.1281C105.563 68.3881 105.811 65.1281 105.747 64.9521C105.683 64.7761 109.683 61.8281 109.683 61.8281C109.683 61.8281 111.991 59.2681 112.115 58.8321C112.239 58.3961 110.495 58.9561 110.115 59.3321C109.689 59.692 109.186 59.9472 108.644 60.0771C108.102 60.207 107.537 60.208 106.995 60.0801C105.371 59.7681 103.247 57.9601 102.935 58.8321C102.748 59.2842 102.706 59.7832 102.815 60.2601Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M105.498 53.0199C105.31 53.1439 103.814 53.5199 103.314 54.7679C102.814 56.0159 100.254 61.7599 99.5062 62.6959C98.7582 63.6319 99.9422 63.2559 100.942 62.6319C101.942 62.0079 102.814 59.5759 103.374 60.6319C103.934 61.6879 105.562 62.1279 105.562 62.1279C105.562 62.1279 108.93 61.5039 109.682 61.0039C110.195 60.6462 110.675 60.2447 111.118 59.8039C111.118 59.8039 113.99 64.1119 114.798 64.4839C115.606 64.8559 115.738 64.2359 115.798 63.5479C116.094 61.0401 116.574 58.5574 117.234 56.1199C118.034 53.4359 116.486 52.5599 115.486 51.4399C114.486 50.3199 113.362 51.0639 112.242 51.1879C111.122 51.3119 105.498 53.0199 105.498 53.0199Z"
        fill="#85C553"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M103.787 33.7961C103.787 33.7961 101.835 36.7601 102.187 37.4801C102.539 38.2001 102.547 39.1441 102.187 39.6481C101.915 39.9794 101.716 40.3646 101.604 40.7783C101.491 41.1919 101.468 41.6247 101.535 42.0481C101.679 43.2761 100.959 49.4881 102.043 50.2121C102.74 50.6656 103.491 51.0298 104.279 51.2961C104.279 51.2961 105.507 61.6961 105.943 61.4081C106.379 61.1201 112.599 54.7481 113.319 53.3721C114.039 51.9961 114.919 50.0521 114.919 50.0521C114.919 50.0521 117.375 45.3561 118.819 43.4041C120.263 41.4521 121.927 37.8441 121.423 35.9641C120.919 34.0841 118.315 32.7121 117.087 31.7001C115.859 30.6881 116.655 28.3801 114.919 27.2241C113.183 26.0681 111.091 25.7801 109.719 26.2841C108.347 26.7881 108.275 27.8841 106.611 26.7881C104.947 25.6921 103.363 24.6241 100.835 25.8521C98.3067 27.0801 97.7987 31.4121 99.3147 32.5681C100.831 33.7241 103.787 33.7961 103.787 33.7961Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M117.078 31.7001C115.85 30.6921 116.646 28.3801 114.91 27.2241C113.174 26.0681 111.082 25.7801 109.71 26.2841C108.338 26.7881 108.266 27.8841 106.602 26.7881C104.938 25.6921 103.354 24.6241 100.826 25.8521C98.2979 27.0801 97.7899 31.4121 99.3059 32.5681C100.822 33.7241 103.786 33.7961 103.786 33.7961C103.786 33.7961 105.954 32.7841 107.386 31.9921C108.818 31.2001 112.082 32.4961 112.658 33.0041C113.234 33.5121 112.37 33.1481 112.226 34.0841C112.082 35.0201 113.886 36.5441 114.682 37.2841C115.478 38.0241 114.538 38.5121 114.322 39.4521C114.106 40.3921 114.97 40.7521 115.478 40.3921C115.986 40.0321 117.57 37.9921 118.15 39.1641C118.73 40.3361 119.594 42.0521 118.006 43.2801C116.418 44.5081 115.258 44.2201 115.258 44.2201C115.258 44.2201 114.742 47.3481 116.242 47.5921C117.021 46.1591 117.874 44.7679 118.798 43.4241C120.246 41.4761 121.906 37.8641 121.402 35.9841C120.898 34.1041 118.306 32.7121 117.078 31.7001Z"
        fill="black"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M107.687 37.6242C108.147 37.4522 108.639 37.3786 109.131 37.4082"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M103.991 38.3359C103.634 38.4114 103.29 38.5352 102.967 38.7039"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M104.014 36.3643C104.271 36.856 104.346 37.4226 104.226 37.9643C103.99 38.7643 101.754 40.5123 101.782 40.8523C101.81 41.1923 103.094 41.9043 103.07 42.1923C103.046 42.4803 102.966 42.9563 102.966 42.9563"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M108.903 38.6239C109.163 38.6239 109.375 38.3642 109.375 38.0439C109.375 37.7235 109.163 37.4639 108.903 37.4639C108.642 37.4639 108.431 37.7235 108.431 38.0439C108.431 38.3642 108.642 38.6239 108.903 38.6239Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M107.982 38.9919C108.618 38.726 109.295 38.5744 109.982 38.5439"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M106.314 35.5123C106.314 35.5123 107.862 34.0763 109.062 34.3643C110.262 34.6523 110.718 35.8083 110.526 35.8123C110.334 35.8163 109.726 34.9243 109.07 34.8563C108.414 34.7883 107.946 35.1003 107.378 35.3883C106.81 35.6763 106.462 35.8763 106.314 35.5123Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M104.119 36.652C104.101 36.5544 104.063 36.4616 104.007 36.3797C103.951 36.2978 103.878 36.2285 103.794 36.1765C103.709 36.1245 103.615 36.0907 103.516 36.0776C103.418 36.0644 103.318 36.072 103.223 36.1C102.515 36.208 101.979 37.496 102.195 37.48C102.411 37.464 102.647 36.652 103.199 36.576C103.751 36.5 104.119 37.364 104.119 36.652Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M102.918 44.5879C102.918 44.5879 104.05 44.4559 105.522 44.2719C106.994 44.0879 109.066 43.7999 109.41 42.7479C109.606 42.2382 109.695 41.6935 109.67 41.1479"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M108.874 41.0682C109.305 41.033 109.739 41.0599 110.162 41.1482"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M114.938 46.2603C114.731 47.2353 114.158 48.0941 113.338 48.6603C112.026 49.4963 102.39 50.4523 102.71 50.5723C103.03 50.6923 104.282 51.2923 104.282 51.2923L104.658 54.7123C106.175 53.3688 107.863 52.231 109.678 51.3283C112.87 49.6723 114.862 49.1243 114.938 46.2603Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M120.315 92.9683C120.315 92.9683 118.523 92.8803 118.075 92.7923C117.627 92.7043 116.195 91.3563 115.567 91.4483C114.939 91.5403 113.779 92.7923 113.331 93.8483C112.883 94.9043 112.703 95.4483 112.703 95.4483C112.703 95.4483 111.103 96.8803 111.903 97.8483C112.703 98.8163 113.607 98.4763 113.607 98.4763C113.607 98.4763 114.143 99.3723 114.859 99.4603C115.39 99.5193 115.924 99.55 116.459 99.5523C116.922 99.6944 117.407 99.7553 117.891 99.7323C118.273 99.6484 118.638 99.4966 118.967 99.2843C119.347 99.3286 119.73 99.2319 120.043 99.0124C120.371 98.7524 121.959 97.1283 122.779 96.2923L123.263 95.7923L120.315 92.9683Z"
        fill="white"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M135.266 74.524C135.266 74.524 131.954 78.196 130.866 79.984C129.132 82.7122 127.249 85.3429 125.226 87.864C123.974 89.296 119.586 92.792 119.586 92.792C119.586 92.792 120.926 95.656 121.914 96.104C122.489 96.3685 123.087 96.5774 123.702 96.728L127.302 94.044C127.302 94.044 134.102 88.844 137.702 85.896C141.302 82.948 146.298 79 146.658 77.3C147.018 75.6 146.746 74.704 144.958 73.36C143.845 72.5363 142.605 71.9012 141.286 71.48"
        fill="#85C553"
      />
      <path
        d="M135.266 74.524C135.266 74.524 131.954 78.196 130.866 79.984C129.132 82.7122 127.249 85.3429 125.226 87.864C123.974 89.296 119.586 92.792 119.586 92.792C119.586 92.792 120.926 95.656 121.914 96.104C122.489 96.3685 123.087 96.5774 123.702 96.728L127.302 94.044C127.302 94.044 134.102 88.844 137.702 85.896C141.302 82.948 146.298 79 146.658 77.3C147.018 75.6 146.746 74.704 144.958 73.36C143.845 72.5363 142.605 71.9012 141.286 71.48"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M122.374 90.5522C122.374 90.5522 123.174 94.4922 125.954 94.4922"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M83.3584 61.5399C83.3584 61.5399 83.7264 64.6879 83.9144 66.1079C83.9681 66.8236 84.1783 67.5186 84.5304 68.1439C84.5304 68.1439 81.6304 74.624 81.5064 74.812C81.3824 75 78.3584 80.6759 77.8624 81.3519C77.3664 82.0279 76.1984 84.1919 76.9384 85.5519C77.6784 86.9119 78.8504 89.688 80.3944 89.748C81.9384 89.808 84.0984 88.8839 85.5944 88.0199C87.0904 87.1559 87.5704 86.5999 87.6944 84.1319C87.8184 81.6639 87.7544 77.2199 88.1904 74.8719C88.6264 72.5239 88.9304 70.0719 89.2384 69.1319C89.5464 68.1919 91.3384 68.5159 91.9544 68.1439C92.5704 67.7719 93.1264 66.9719 94.2384 66.4759C95.2028 66.1093 96.2517 66.0246 97.2624 66.2319C97.6344 66.3559 98.3104 65.7999 98.1264 65.1199C97.9424 64.4399 96.7064 64.0719 95.4704 64.1919C94.2344 64.3119 93.1264 64.6879 92.8184 64.5039C92.5104 64.3199 92.2024 61.0439 92.2024 61.0439C92.2024 61.0439 87.8024 61.4159 86.2744 61.4759C84.7464 61.5359 83.3584 61.5399 83.3584 61.5399Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M90.1465 59.1321C90.1465 59.1321 90.2105 63.2081 90.2105 63.5761C90.2113 63.662 90.2298 63.7467 90.2648 63.8251C90.2999 63.9034 90.3507 63.9737 90.4142 64.0315C90.4776 64.0893 90.5523 64.1334 90.6336 64.1611C90.7148 64.1887 90.8009 64.1993 90.8865 64.1921C91.1985 64.1321 91.9985 64.4401 92.1865 63.5161C92.3745 62.5921 92.7385 59.9961 92.5545 59.3801C92.3705 58.7641 90.7025 58.5161 90.1465 59.1321Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M90.1463 59.1321C90.1463 59.1321 88.1743 58.6401 87.6183 58.9481C87.0623 59.2561 87.9263 63.6401 87.9863 64.0081C88.0463 64.3761 88.9143 64.5641 89.2823 64.4401C89.6503 64.3161 90.2103 64.0721 90.2103 63.5761C90.2103 63.0801 90.1463 59.1321 90.1463 59.1321Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M87.1864 59.0721C87.1864 59.0721 85.8904 58.8242 85.5184 59.2562C85.1464 59.6882 85.0264 60.3041 85.1464 61.4161C85.3096 62.5106 85.6429 63.5727 86.1344 64.5641C86.3824 64.9361 87.1864 64.9962 87.6784 64.8122C88.1704 64.6282 87.9864 64.0122 87.9864 64.0122C87.9864 64.0122 87.7384 63.7641 87.6784 61.8521C87.6184 59.9401 87.6184 58.9521 87.6184 58.9521L87.1864 59.0721Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M85.0264 59.812C84.7784 59.872 83.2344 59.936 83.1744 60.552C83.1144 61.168 83.6665 64.072 83.9145 64.38C84.1625 64.688 84.8384 64.564 85.0864 64.44C85.3344 64.316 85.7664 64.132 85.7025 63.76C85.6385 63.388 85.0264 59.812 85.0264 59.812Z"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M85.5181 72.0321C85.0747 71.9615 84.6573 71.7769 84.3067 71.4964C83.9561 71.2159 83.6844 70.8492 83.5181 70.4321C82.6701 72.3201 81.5901 74.7081 81.5181 74.8321C81.3941 75.0161 78.3701 80.6961 77.8741 81.3721C77.3781 82.0481 76.2101 84.2121 76.9501 85.5721C77.6901 86.9321 78.8621 89.7081 80.4061 89.7681C81.9501 89.8281 84.1101 88.9041 85.6061 88.0401C87.1021 87.1761 87.5821 86.6201 87.7061 84.1521C87.8301 81.6841 87.7661 77.2401 88.2021 74.8921C88.4101 73.7401 88.6021 72.5641 88.7621 71.5481C87.7205 71.9107 86.6202 72.0749 85.5181 72.0321Z"
        fill="#85C553"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M88.3582 65.2441C88.3582 65.2441 87.3062 66.1681 87.1862 66.9721C87.1238 67.4859 87.232 68.0059 87.4942 68.4521"
        fill="white"
      />
      <path
        d="M88.3582 65.2441C88.3582 65.2441 87.3062 66.1681 87.1862 66.9721C87.1238 67.4859 87.232 68.0059 87.4942 68.4521"
        stroke="black"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ProfileCreatedModalIcon;
